import React, {useState} from "react";
import {Layout, Divider, Row, Col, Modal} from "antd";
import PageHeader from "../../components/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import IndexCard from "../../components/IndexCard";
import PdfPreview from "../../components/PdfPreview";
import {ClientAdvantageBulletPoints, FiniatSolutionBulletPoints, MarketBulletPoints} from "./indexCardConfig";


const pdfConfig = [
    {
        title: "Whitepaper",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/whitepapers/Intelligent%20Allocation%20%28Styled%29.pdf'
    },
    {
        title: "Why FINIAT",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/why-finiat.pdf'
    },
    {
        title: "Beta as an Outcome",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/Beta%20as%20an%20Outcome%2C%20Not%20a%20Target%20v2.pdf'
    },
    {
        title: "Debunking Goals Based Investing",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/Debunking%20Goal%20Based%20Investing.pdf'
    },
    {
        title: "What we Do",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/reports/What%20We%20Do.pdf'
    },
    {
        title: "Taxes in Active Turnover Strategies",
        url: 'https://storage.googleapis.com/resources.iaplatform.app/onePagers/Understanding%20Taxes%20in%20Strategies%20with%20Turnover.pdf'
    }
]

const Resources = ()=>{
    const [showModal, setShowModal] = useState(false);
    const [selectedIndexCard, setSelectedIndexCard] = useState(null);
    const orderedIndexCards =[
        ClientAdvantageBulletPoints,
        FiniatSolutionBulletPoints,
        MarketBulletPoints
    ];

    const handleCardClick = (cardConfig)=>{
        setShowModal(true);
        setSelectedIndexCard(cardConfig);
    }

    return (
        <Layout>
            <PageHeader title={'Resources'} logoUrl={iconMapping.resources}/>
            <Layout.Content className={'p-6'}>
                <Row wrap={false}>
                    <Col flex={'0 0 600px'}>
                        {orderedIndexCards.map((card, index) => (
                            <>
                                <IndexCard key={index} {...card} onCardClick={()=>handleCardClick(card)}/>
                                <Divider/>
                            </>
                            )
                        )}
                    </Col>
                    <Col flex={'auto'}>
                        <Row gutter={64} justify={'start'} wrap={true}>
                            {pdfConfig.map((pdf, index) => (
                                <Col flex={'0 0 200px'}>
                                    <PdfPreview key={index}
                                                bucketUrl={pdf.url}
                                                title={pdf.title}
                                    />
                                </Col>

                            ))}
                        </Row>
                    </Col>
                </Row>
            </Layout.Content>
            <Modal className={'transparent'} width={650} open={showModal} onCancel={()=>setShowModal(false)} onOk={()=>setShowModal(false)}>
                <IndexCard {...selectedIndexCard} size={'large'} shadow={true}/>
            </Modal>
        </Layout>
    )
}

export default Resources;